import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import { Divider } from 'antd';
import 'antd/dist/antd.css';
import axios from 'axios';
import { push } from "connected-react-router";
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toastr } from "react-redux-toastr";
import { default as Select } from 'react-select';
import { Button, Col, FormGroup, Label, Row } from "reactstrap";
import { CallAxiosRequest, CallLocalRequestGetNoCache, GetAxiosResponse } from '../../Helpers/axiosHelpers';
import { CheckIfCompanyIs, DisplayZendDeskChat, EPlatforms, GetPermissionDetailsByName, ReturnLanguageOptionsHtML, ValidateSelect, VERSION } from '../../Helpers/DataHelpers';
import { BasicSelectOption } from '../../Interfaces/IApplicationForm';
import { DashboardItems, GetCompanyDataResult, LoadCompanyLogoResult, LoginClientResponse, PushNotification as PushNotificationClass, translationType, UserPermissionOBjectClass, YoonitRequest, YoonitRequestNoParam } from '../../Interfaces/Interfaces';
import { Login, Logout, UpdateIsValid } from '../../redux/actions/AuthActions';
import { UpdateCompanySettings } from '../../redux/actions/CompanySettingsAction';
import { UpdateDashboard } from '../../redux/actions/DashboardActions';
import { ChangeLanguage } from '../../redux/actions/languageAction';
import { AddNewMessage, RemoveAllMessages } from '../../redux/actions/NotificationActions';
import { ClearPushNotifications, PushNotification, SetSignalR } from '../../redux/actions/PushNotificationActions';
import { ADDSERVERS, HandleServerConnectivity } from '../../redux/actions/ServersConnectivityAction';
import { GetAdminData, GetClientData, ILanguageData, IStore, IUserData } from '../../redux/constants';
import { INotificationStore } from '../../redux/reducers/NotificationReducer';

declare var require: any;
const { SpinnerComponent }: any = require('react-element-spinner');
const $ = require("jquery");
interface IProps {
    LanguageData: ILanguageData;
    language: BasicSelectOption;
    ClientData: GetClientData;
    Logout: any;
    Login: any;
    ChangeLanguage: any;
    UpdateLanguage: any;
    lang: translationType;
    router: any;
    push: any;
    theme: any;
    userData: IUserData;
    AdminData: GetAdminData;
    Notifications: INotificationStore;
    AddNewMessage: any;
    PushNotificationSettings: any;
    PushNotification: any;
    UpdateDashboard: any;
    UpdateCompanySettings: any;
    SetSignalR: any;
    IsEnabled: any;
    IsEnabledDESCRIPTION: any;
    isAuth: boolean;
    isTokenExpired: boolean;
    isTokenValid: boolean;
    DashboardItems: DashboardItems[];
    i18n: any;
    t: any;
    UpdateIsValid: any;
    ClearPushNotifications: any;
    RemoveAllMessages: any;
    ADDSERVERS: any;
    HandleServerConnectivity: any;
    CompanyDataProps: GetCompanyDataResult;
    CompanySettings: LoadCompanyLogoResult;
    location: any;
}
interface IState {
    cdnLink: string;
    username: string;
    password: string;
    languageChosen: translationType;
    isLoading: boolean;
    headerTitle: string;
    imagesSrc: string;
    imgDesc: string;
    circular: boolean;
    picture: string
    openAccType: boolean;
    GetCompanyDataResult: GetCompanyDataResult;
    userData: IUserData;
    applicationTypeOption: BasicSelectOption[];
    applicationTypeSelectedOption: any;
    loginResponse: any;
    LightLogo: string;
    DarkLogo: string;
    IsCircular: boolean;
    GetURL: string;
    ActionURL: string;
    htmlContent: any;
    immutablehtmlContent: any;

}
const mapStateToProps = (state: IStore) => ({
    ClientData: state.auth.ClientData,
    AdminData: state.auth.AdminData,
    userData: state.auth.UserData,
    lang: state.language.lang,
    language: state.language,
    router: state.router,
    theme: state.theme,
    Notifications: state.Notifications,
    PushNotificationSettings: state.PushNotifications.PushNotificationStatus,
    isAuth: state.auth.isAuth,
    isTokenExpired: state.auth.isTokenExpired,
    isTokenValid: state.auth.isTokenValid,
    DashboardItems: state.Items,
    CompanyDataProps: state.CompanyData,
    CompanySettings: state.CompanySettings,
    LanguageData: state.LanguageData,
    location: state.router.location,
});
const dispatchProps = { push, Login, Logout, ChangeLanguage, AddNewMessage, PushNotification, SetSignalR, UpdateDashboard, UpdateCompanySettings, UpdateIsValid, ClearPushNotifications, RemoveAllMessages, ADDSERVERS, HandleServerConnectivity };
let BUID: string;
class SignIn extends React.PureComponent<any, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            cdnLink: "",
            applicationTypeSelectedOption: { value: 0, label: "", RequireKYC: false },
            applicationTypeOption: [],
            username: '',
            password: '',
            languageChosen: 'en',
            isLoading: false,
            headerTitle: '',
            imagesSrc: "",
            imgDesc: "",
            circular: false,
            picture: '',
            openAccType: false,
            GetCompanyDataResult: new GetCompanyDataResult(),
            userData: {
                id: "",
                Token: "",
                RefreshToken: "",
                isAdmin: false,
                isFirstUser: false,
                yoonitGetURL: "",
                yoonitActionURL: "",
                UserName: "",
                Language: "en",
                TimeZone: 0,
            },
            loginResponse: {} as any,
            LightLogo: '',
            DarkLogo: '',
            IsCircular: false,
            GetURL: "https://uat-get-yoonit.azurewebsites.net/api/",
            ActionURL: "https://uat-actions-yoonit.azurewebsites.net/api/",
            htmlContent: null as any,
            immutablehtmlContent: null as any,
        };
    }
    componentDidMount() {
        this.GetCompanyData();
        document.documentElement.setAttribute('lang', this.props.i18n.language);
        if (this.props.i18n.language === "ar") {
            document.documentElement.setAttribute('dir', "rtl");
        }
        else {
            document.documentElement.setAttribute('dir', "ltr");
        }
        DisplayZendDeskChat(false);
    }
    componentWillUnmount() {
    }
    openAccType = () => {
        this.setState({ openAccType: true }, this.GetApplicationTypeList)
    }
    closeAccType = () => {
        this.setState({ openAccType: false })
    }
    handleChange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value } as any);
    };
    LoadCompanyLogo = () => {
        this.setState({
            LightLogo: this.props.CompanySettings.LightLogo,
            DarkLogo: this.props.CompanySettings.DarkLogo,
            IsCircular: this.props.CompanySettings.IsCircular
        }, this.UpdateDyanmicDesgin);
    }
    UpdateDyanmicDesgin = () => {
        let _src = this.state.LightLogo || ""; //as themes removed
        $('#logo').attr('src', _src);
        $('#logo').attr('class', this.state.IsCircular ? "circularLogo" : " logoSignin");
        $('#logo2').attr('src', _src);
        $('#logo2').attr('class', this.props.CompanySettings?.IsCircular ? "circularLogo displayOnSmallScreens" : " logoSignin displayOnSmallScreens");
    }
    GetApplicationTypeList = () => {
        let GetRegSettingPermsParams: any = {
            CompanyName: this.state.GetCompanyDataResult.CompanyCode,
            Token: this.state.userData.Token,
            ObjData: this.state.loginResponse?.ClientData?.PoolID ? this.state.loginResponse.ClientData.PoolID : 0

        };

        CallAxiosRequest<any, any>(
            this.state.GetURL,
            `CRM/GetApplicationTypeList`,
            GetRegSettingPermsParams,
            { Token: this.state.userData.Token },
            (res: any) => {
                this.setState({
                    applicationTypeOption: this.FillApplicationSelectOptions(res.data.ListRes, "applicationTypeSelectedOption", "KTID", "TypeName", "RequireKYC")
                })
            },
            () => {
            },
            this.props.t
        );

    }
    FillApplicationSelectOptions = (SelectOpt: any, stateName: string, value: string, label: string, RequireKYC: string) => {
        let _options: any[] = [];

        for (let k = 0; k < SelectOpt.length; k++) {
            if (!!SelectOpt[k].IsEnabledType) {
                _options.push({
                    ...SelectOpt[k],
                    value: SelectOpt[k][value],
                    label: SelectOpt[k][label],
                    RequireKYC: SelectOpt[k][RequireKYC]
                });
            }
        }
        if ((!_options || _options.length === 0) && stateName === "applicationTypeSelectedOption") {
            _options.push({ value: -1, label: 'No Application', RequireKYC: false });
            this.setState({ applicationTypeSelectedOption: _options[0] })
        }
        if ((_options && _options.length > 0) && stateName === "applicationTypeSelectedOption")
            this.setState({ applicationTypeSelectedOption: _options[0] })


        return _options;
    };
    applicationTypeSelectedOptionOnchange = (applicationTypeSelectedOption: any) => {
        this.setState({ applicationTypeSelectedOption })
    }

    handleSubmit = async () => {
        let _userName = $("#email").val();
        let _password = $("#password").val();
        var data = {
            Username: _userName,
            Password: btoa(_password)
        };

        if (!_userName || !_password) {
            this.setState({ isLoading: false });
            toastr.warning('', this.props.t('FillFields'));
        }
        this.setState({ isLoading: true });
        const res = await axios.post<LoginClientResponse>('api/auth/LoginClient', data); // add interface 
        let ClientsUserPerms: UserPermissionOBjectClass = GetPermissionDetailsByName('Clients', res.data.UserPermissions);

        if (!res.data.CompanyAuth) {
            toastr.warning('', this.props.t('SessionNotAuthorized'));
            this.setState({ isLoading: false });
        }
        else {
            if (res.data.isAuth === true) {
                if (res.data.UserData.isAdmin) {
                    this.props.ADDSERVERS(this.ConvertIntoDictionary(res.data.Servers, "ServerID"));
                }
                if (res.data.CompanyData.IsCompanyExpired) {
                    this.setState({ isLoading: false, });
                    toastr.warning('', this.props.t('Companylicenseisexpired'));
                }
                else if (res.data.UserData.isAdmin && res.data.UserData.isFirstUser) {
                    this.props.Login(res.data);//as need username and other data
                    this.props.push("/FirstUser");
                }
                else if (res.data.UserData.isAdmin && (res.data.AdminData.IsBlocked === null ? true : res.data.AdminData.IsBlocked)) {
                    toastr.warning('', this.props.t('UserisBlocked'));
                    this.setState({ isLoading: false, });
                }
                else if (!res.data.UserData.isAdmin && (res.data.ClientData.IsBlocked === null ? true : res.data.ClientData.IsBlocked)) {
                    toastr.warning('', this.props.t('UserisBlocked'));
                    this.setState({ isLoading: false, });
                }
                else if (!res.data.UserData.isAdmin && !res.data.ClientData.IsActive) {
                    toastr.warning(this.props.t('Accessdenied'), this.props.t('YouraccountneedsActivation'));
                    this.setState({ isLoading: false, });
                }
                else {
                    if (res.data.UserData.isAdmin) {
                        this.setState({ userData: res.data.UserData }, () => {
                            this.GetPushNotificationSettings(res.data.AdminData.AUID);
                            //this.LoadCompanyLogo();//TODO Cehk All external urls
                        })
                        DisplayZendDeskChat(true);
                    }
                    else {
                        DisplayZendDeskChat(false);
                        this.setState({ userData: res.data.UserData }/*, this.LoadCompanyLogo*/)
                    }
                    if (!res.data.UserData.isAdmin) {

                        let _hasKYC = res.data.UserData && !res.data.UserData.isAdmin && res.data.ClientData ? res.data.ClientData.hasKYC : false;
                        let _IsValid = res.data.UserData && !res.data.UserData.isAdmin && res.data.ClientData && res.data.ClientData.IsValid ? true : false;
                        BUID = res.data.UserData && !res.data.UserData.isAdmin && res.data.ClientData ? res.data.ClientData.BUID : "";

                        this.props.ChangeLanguage(this.props.LanguageData.Dict[res.data.ClientData.Language]);
                        //this.props.UpdateLanguage(res.data.ClientData.Language);
                        this.props.UpdateDashboard(res.data.Items);
                        if (res.data.ClientData.KTID === null && res.data.ClientData.RequireKYC && !_hasKYC && res.data.CompanyData.IsCRM) {
                            this.setState({ loginResponse: res.data }, this.openAccType);
                            this.setState({ isLoading: false })
                        }
                        else if (!res.data.CompanyData.IsCRM || (res.data.CompanyData.IsCRM && (!res.data.ClientData.RequireKYC || (res.data.ClientData.RequireKYC && _IsValid)))) {
                            this.props.Login(res.data);
                            this.AddAuthenticationLog(res.data);
                            if (this.state.GetCompanyDataResult?.CompanyCode?.toLowerCase() === "tnfx"
                                || (this.state.GetCompanyDataResult?.CompanyCode?.toLowerCase() === "malfex" && res?.data?.CompanyData?.IsIB)
                            ) {
                                this.props.push("/MyWallet");
                            } else {
                                this.props.push("/Manage/MyAccounts");
                            }
                        }
                        else if (res.data.CompanyData.IsCRM && res.data.ClientData.RequireKYC && !_IsValid) {
                            this.props.Login(res.data);
                            this.AddAuthenticationLog(res.data);
                            if (this.state.GetCompanyDataResult?.CompanyCode?.toLowerCase() === "tnfx") {
                                this.props.push("/MyWallet");
                            } else {
                                this.props.push("/OnBoarding/ApplicationForm");
                            }
                        } else {// can remove as haskyc should not come null
                            this.props.Login(res.data);
                            this.AddAuthenticationLog(res.data);
                            if (this.state.GetCompanyDataResult?.CompanyCode?.toLowerCase() === "tnfx") {
                                this.props.push("/MyWallet");
                            } else {
                                this.props.push(res.data.defaultpage);
                            }
                        }
                    }
                    else {
                        this.props.ChangeLanguage(this.props.LanguageData.Dict[res.data.AdminData.Language]);
                        //this.props.UpdateLanguage(res.data.AdminData.Language);
                        this.props.Login(res.data)

                            ;//as Else will be handle with in new Action 
                        if (res.data.UserData.isAdmin && res.data.CompanyData.IsBonus && ClientsUserPerms.Allowed) {
                            this.props.push("/Clients/ClientPage")
                            this.AddAuthenticationLog(res.data);
                        }
                        //else if (res.data.UserData.isAdmin)
                        //    this.props.push("/");
                        //else if (res.data.defaultpage) {
                        //    this.props.push(res.data.defaultpage);
                        //}
                        else {
                            this.props.push(res.data.defaultpage);
                            this.AddAuthenticationLog(res.data);
                        }
                        this.setState({ isLoading: true });

                    }
                }
            }
            else {
                this.setState({
                    isLoading: false,
                    password: ""
                });
                $("#password").val('');
                toastr.warning('', this.props.t('InvalidCredentials'));
            }
        }

    }

    onAccTypeSave = async () => {
        let _loginResponse = this.state.loginResponse;
        let GetRegSettingPermsParams: any = {
            CompanyName: this.state.GetCompanyDataResult.CompanyCode,
            Token: this.state.userData.Token,
            ObjData: ValidateSelect(this.state.applicationTypeSelectedOption) ? this.state.applicationTypeSelectedOption.value : null,
            BUID: BUID
        };
        if (!ValidateSelect(this.state.applicationTypeSelectedOption) || +(this.state.applicationTypeSelectedOption.value) <= 0) {
            toastr.warning('', this.props.t('FillRequiredFields'));
        } else {
            const UpdateClientKYCTypeResponse: any = await GetAxiosResponse<any, any>(
                this.state.ActionURL,
                `Trader/UpdateClientKYCType`,
                GetRegSettingPermsParams,
                { Token: this.state.userData.Token },
                () => { },
                () => { },
                this.props.t
            );
            if (this.state.applicationTypeSelectedOption.RequireKYC)
                if (UpdateClientKYCTypeResponse.data.IntRes > 0) {
                    if (CheckIfCompanyIs('PLUGIT') || CheckIfCompanyIs('IQX')) {
                        _loginResponse.ClientData.RequireKYC = true;
                        _loginResponse.ClientData.hasKYC = true;
                        _loginResponse.ClientData.IsValid = true;
                        this.props.Login(_loginResponse);
                        this.props.UpdateIsValid(true);
                        this.AddAuthenticationLog(_loginResponse);
                        this.props.push("/OnBoarding/ApplicationForm");
                    } else {
                        _loginResponse.ClientData.RequireKYC = true;
                        _loginResponse.ClientData.IsValid = false;
                        this.props.Login(_loginResponse);
                        this.props.UpdateIsValid(false);//hardcoded as valid is sent true by login first Time before change //@point can be removed
                        this.AddAuthenticationLog(_loginResponse);
                        this.props.push("/OnBoarding/ApplicationForm");
                    }
                }
                else
                    toastr.warning('', this.props.t('FailedAction'));
            else {
                _loginResponse.ClientData.RequireKYC = false;
                this.props.Login(_loginResponse);
                this.AddAuthenticationLog(_loginResponse);
                this.props.push("/Manage/MyAccounts");
            }
        }
    }
    AddAuthenticationLog = (loginResData: LoginClientResponse) => {
        try {
            let Params: YoonitRequest<string> = {
                CompanyName: this.state.GetCompanyDataResult.CompanyCode,
                Token: this.state.userData.Token,
                UserName: loginResData.UserData.isAdmin ? loginResData.AdminData.Email : loginResData.ClientData.Email,
                ClientName: loginResData.UserData.isAdmin ?
                    `${loginResData.AdminData.FirstName ? loginResData.AdminData.FirstName : ""} ${loginResData.AdminData.LastName ? loginResData.AdminData.LastName : ""}`
                    : `${loginResData.ClientData.FirstName ? loginResData.ClientData.FirstName : ""} ${loginResData.ClientData.LastName ? loginResData.ClientData.LastName : ""}`,
                ObjData: "Login",
            };

            CallAxiosRequest<any, any>(
                this.state.ActionURL,
                `Trader/AddAuthenticationLog`,
                Params,
                { Token: this.state.userData.Token },
                () => { },
                () => { },
                this.props.t
            );
        } catch (e) {

        }
    }
    AddAuthenticationLogLogout = async () => {
        let Params: YoonitRequest<string> = {
            CompanyName: this.state.GetCompanyDataResult.CompanyCode,
            Token: this.state.userData.Token,
            ClientName: this.props.userData.isAdmin ?
                `${this.props.AdminData.FirstName ? this.props.AdminData.FirstName : ""} ${this.props.AdminData.LastName ? this.props.AdminData.LastName : ""}`
                : `${this.props.ClientData.FirstName ? this.props.ClientData.FirstName : ""} ${this.props.ClientData.LastName ? this.props.ClientData.LastName : ""}`,
            ObjData: "Logout",
        };
        const res: any = await GetAxiosResponse<any, any>(
            this.state.ActionURL,
            `Trader/AddAuthenticationLog`,
            Params,
            { Token: this.state.userData.Token },
            () => {
                try {
                    if (res && res.data && res.data.IntRes === 0) {
                        //toastr.warning('', this.props.t('ReqSentSuccess'));
                    }
                    else {
                        toastr.warning('', this.props.t('FailedAction'));
                    }
                } catch (e) {
                }
            },
            () => {
            },
            this.props.t
        );
    }
    GetPushNotificationSettings = (AUID: string) => {
        let Parms: YoonitRequestNoParam = {
            CompanyName: this.state.GetCompanyDataResult.CompanyCode,
            Token: this.state.userData.Token,
            AUID: AUID
        };
        this.setState({ isLoading: true });
        CallAxiosRequest<any, any>(
            this.state.GetURL,
            `Settings/GetPushNotificationSettings`,
            Parms,
            { Token: this.state.userData.Token },
            (res: any) => {
                if (res.data.ListRes) {
                    this.setPushNotifcations(res.data.ListRes);
                }
                this.setState({ isLoading: false });
            },
            () => {
                this.setState({ isLoading: false });
            },
            this.props.t
        );
    }
    setPushNotifcations = (list: PushNotificationClass[]) => {
        list = list.sort((a: PushNotificationClass, b: PushNotificationClass) => !a.OrderNumber ? 1 : !b.OrderNumber ? -1 : ((a.OrderNumber > b.OrderNumber) ? 1 : -1));
        this.props.PushNotification(this.castToPushNotificationStatusRedux(list));
    }
    castToPushNotificationStatusRedux = (list: any) => {
        let _newlist: any = [...list];
        _newlist = _newlist.map((item: PushNotificationClass) => {
            return {
                PNID: item.PNID,
                IsEnabled: item.IsEnabled,
                PNDescription: item.PNDescription
            }
        })
        return { PushNotificationStatus: _newlist };
    }
    onLanguageChange = async (selectedLanguage: any) => {
        await this.props.ChangeLanguage(selectedLanguage);
        await this.props.i18n.changeLanguage(selectedLanguage.value);
        document.documentElement.setAttribute('lang', selectedLanguage.value);
        if (selectedLanguage.value === "ar") {
            document.documentElement.setAttribute('dir', "rtl");
        }
        else {
            document.documentElement.setAttribute('dir', "ltr");
        }
    }
    ConvertIntoDictionary = (list: any[], key: any) => {
        let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
            obj[`${item[key]}`] = item ? { ServerID: item.ServerID, IsConnected: item.ServerIsConnected, ID: `${item.ServerID}` } : {}
            if (item.ServerType === EPlatforms.MT5)//add both
                obj[`${item[key]}WebAPI`] = item ? { ServerID: item.ServerID, IsConnected: item.APIServerIsConnected, ID: `${item.ServerID}WebAPI` } : {}
            return obj
        }, {});
        return _newDict;
    }
    navigateToRealAccount = () => {
        this.props.push('/RealAccount');
    }
    navigateToRealAccountICONFX = () => {
        this.props.push('/RealAccount?PID=1');
    }
    navigateToRealAccountSquared = () => {
        window.location.replace('https://sc.squaredfinancial.com/register');
    }
    navigateToRealAccount_TNFX = () => {
        window.location.replace('https://my.tnfx.co/partner/register');
    }
    navigateToRealAccountMaleyatIB= () => {
        window.location.replace('https://maleyat.com/register-introducing-broker-trading-account');
    }
    navigateToResetPassword = () => {
        this.props.push('/ResetPassword');
    }
    //#region html Functionality
    RunHtmlFunctions = () => {
        this.LoadCompanyLogo();
        let _ref = this;
        $("#languageDropdownRadioGroup").html(ReturnLanguageOptionsHtML(this.props.LanguageData.Options));
        $(document).ready(function () {
            $("#SubmitBtn").on("click", function (this: any, e: any) {
                //e.preventDefault();
                //console.log(e, 'SubmitBtn');
                _ref.handleSubmit();
            });
            $("#langName").text(_ref.props.LanguageData.Dict[_ref.props.language?.value]?.label ? _ref.props.LanguageData.Dict[_ref.props.language?.value]?.label : "Language");
            $(".openLanguage").on("click", function (e: any) {
                e.preventDefault();
                $(".languageDropdown").toggle("show");
            });
            $("#navigateToRealAccountICONFX").on("click", function (this: any, e: any) {
                e.preventDefault();
                _ref.navigateToRealAccountICONFX();
            });
            $("#navigateToRealAccountMaleyatIB").on("click", function (this: any, e: any) {
                e.preventDefault();
                _ref.navigateToRealAccountMaleyatIB();
            });
            $("#navigateToRealAccountSquared").on("click", function (this: any, e: any) {
                e.preventDefault();
                _ref.navigateToRealAccountSquared();
            });
            $("#navigateToRealAccount_TNFX").on("click", function (this: any, e: any) {
                e.preventDefault();
                _ref.navigateToRealAccount_TNFX();
            });
            $("#navigateToRealAccount").on("click", function (this: any, e: any) {
                e.preventDefault();
                _ref.navigateToRealAccount();
            });
            $("#navigateToResetPassword").on("click", function (this: any, e: any) {
                e.preventDefault();
                _ref.navigateToResetPassword();
            });
            $('input[name="languageChecked"]').on("click", function (this: any, e: any) {
                //e.preventDefault();
                console.log('languageChecked');
                console.log($(this).val());
                //let lang = $(this).find(':selected').data('lang');
                let lang = $(this).val();
                $("#langName").text(_ref.props.LanguageData.Dict[lang]?.label ? _ref.props.LanguageData.Dict[lang]?.label : "Language");
                _ref.ChangeLanguageAndImage(lang);
            });
            $(".toggle-password").click(function (this: any) {
                $(this).toggleClass("fa-eye fa-eye-slash");
                var input = $($(this).attr("toggle"));
                if (input.attr("type") === "password") {
                    input.attr("type", "text");
                } else {
                    input.attr("type", "password");
                }
            });
            $("#email").on("keypress", function (this: any, e: any) { if (e?.which === 13) { _ref.handleSubmit(); } });//on enter click
            $("#password").on("keypress", function (this: any, e: any) { if (e?.which === 13) { _ref.handleSubmit(); } });
            $("#languageDropdown").on("change", function (this: any, e: any) {
                //e.preventDefault();
                let lang = $(this).find(':selected').data('lang');
                _ref.ChangeLanguageAndImage(lang);
            });
        });
        $('#imageToSwap').attr('src', $(`#languageDropdown option[data-lang="${_ref.props.language?.value}"]`).val());
        $(`#languageDropdown option[data-lang="${_ref.props.language?.value}"]`).prop("selected", true);
        $('#version').text(VERSION);
        $(`input[name="languageChecked"][value="${_ref.props.language?.value}"]`).prop("checked", 'checked');
    }
    ChangeLanguageAndImage = async (lang: string) => {
        let _ref = this;
        await this.onLanguageChange(_ref.props.LanguageData.Dict[lang])
        $('#SubmitBtn').off('click');
        $('#languageDropdown').off('change');//remove as htm changed 
        $(`input[name="languageChecked"][value="${_ref.props.language?.value}"]`).prop("checked", 'checked');
        $('input[name="languageChecked"]').off('click');//remove as htm changed 
        this.setState({ htmlContent: this.TranslateKeyWords(this.state.immutablehtmlContent) }, this.RunHtmlFunctions)
    }
    TranslateKeyWords = (html: string) => {
        let _res = html.replace(/%(.*?)%/g, this.translatevalue)
        return _res;
    }
    translatevalue = (value: any, p1: any) => {
        return this.props.t(p1);
    }
    GetLoginPage = () => {
        CallLocalRequestGetNoCache<any, any>
            (`${this.props.CompanyDataProps.BannerCDNURL}${this.props.CompanyDataProps.CompanyCode?.toLowerCase().trim()}/templates/LoginPageContent.txt`,
                {}, (res: any) => {
                    this.setState({
                        htmlContent: this.TranslateKeyWords(res.data),
                        immutablehtmlContent: res.data,
                    }, this.RunHtmlFunctions);
                }, () => {
                    this.GetDefaultLoginPage();
                });
    }
    GetDefaultLoginPage = () => {
        CallLocalRequestGetNoCache<any, any>
            (`${this.props.CompanyDataProps.BannerCDNURL}templates/LoginPageContent.txt`,
                {}, (res: any) => {
                    this.setState({
                        htmlContent: this.TranslateKeyWords(res.data),
                        immutablehtmlContent: res.data,
                    }, this.RunHtmlFunctions);
                }, () => {
                });
    }
    GetCompanyData = () => {
        this.setState({ isLoading: true })
        axios.post<GetCompanyDataResult>("api/auth/GetCompanyData")
            .then(res => {
                this.setState({
                    GetCompanyDataResult: res.data ? res.data : new GetCompanyDataResult(),
                    GetURL: res?.data?.YoonitGetURL ? res?.data?.YoonitGetURL : this.props.CompanyDataProps.YoonitGetURL,
                    ActionURL: res?.data?.YoonitActionURL ? res?.data?.YoonitActionURL : this.props.CompanyDataProps.YoonitActionURL,
                    cdnLink: res?.data?.CDNURL ? res?.data?.CDNURL : this.props.CompanyDataProps.CDNURL
                }, this.GetLoginPage);
                this.setState({ isLoading: false });
            })
            .catch((e: any) => {
                console.error(e);
                this.setState({
                    GetCompanyDataResult: this.props.CompanyDataProps,
                    GetURL: this.props.CompanyDataProps.YoonitGetURL,
                    ActionURL: this.props.CompanyDataProps.YoonitActionURL,
                    cdnLink: this.props.CompanyDataProps.CDNURL
                }, this.GetLoginPage);
                this.setState({ isLoading: false });
            });
    }
    //#endregion
    public render() {
        return (
            <div>
                {this.state.openAccType &&
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={"Model ModalPop "}
                        open={this.state.openAccType}
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={this.state.openAccType}>
                            <div className={"ModelPaper2 ModalPopBody m10mr10 ModalLogin ModalAllocation"}>
                                <div >
                                    <h2 className="TitleModal">{this.props.t('ChooseApplicationType')}<div className="ml-auto floatRight">
                                        <div className="xHoverIcon2">
                                        </div>
                                    </div></h2>

                                    <Divider />
                                </div>
                                < div className="m10">

                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="allocate" className="LabelCreate2 d-contents" >{this.props.t('ApplicationTypes')}</Label>
                                                <Select
                                                    className="react-select-container MedSelect"
                                                    classNamePrefix="react-select cursor-pointer LargeSelect  "
                                                    isSearchable={true}
                                                    isMulti={false}
                                                    options={this.state.applicationTypeOption}
                                                    value={this.state.applicationTypeSelectedOption}
                                                    onChange={this.applicationTypeSelectedOptionOnchange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div>
                                        <div className="floatRight mt-2">
                                            <Button className="mr-3 ButtonsModal mb-2" onClick={this.onAccTypeSave}> {this.props.t('Save')} </Button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </Fade>
                    </Modal>
                }
                {!this.state.openAccType &&
                    <>
                        <SpinnerComponent loading={this.state.isLoading} position="centered" color="#00ad0f" />
                        <div className={this.state.isLoading ? "blurBackground " : ""}>
                            {this.state.htmlContent && <div dangerouslySetInnerHTML={{ __html: this.state.htmlContent }} />}
                        </div>
                    </>
                }
            </div >
        );
    }
};

export default withTranslation()(connect(mapStateToProps, dispatchProps)(SignIn));
